const Grocery = () => {
    return <div>
        <h1>This is an Grocery page</h1>
    </div>;
};

export default Grocery;
